module.exports = __webpack_public_path__ + "img/attendance.105841cc.svg";